import * as React from 'react';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import type {EventFragmentSparse} from 'nutshell-graphql-types';

import {TimelineBanner} from './timeline-banner';

import styles from './timeline-banner.module.css';

type Props = {
    event: EventFragmentSparse;
};

export function TimelineBannerLeadCloned(props: Props) {
    const {event} = props;

    const payload = event.payload;

    if (payload.__typename !== 'LeadClonePayload') {
        return null;
    }

    const original = payload.original;
    const clone = payload.clone;

    const action = (
        <span>
            cloned&nbsp;
            <span className={styles['target']}>
                <LinkedEntity
                    type={'leads'}
                    useEntityColor={true}
                    greenLeads={true}
                    shouldClientRoute={true}
                    allowWrap={true}
                    displayInline={true}
                    {...original}
                />
            </span>
            &nbsp;into&nbsp;
            <span className={styles['target']}>
                <LinkedEntity
                    type={'leads'}
                    useEntityColor={true}
                    greenLeads={true}
                    shouldClientRoute={true}
                    allowWrap={true}
                    displayInline={true}
                    {...clone}
                />
            </span>
        </span>
    );

    return (
        <TimelineBanner
            id={event.id}
            iconVariant={'lead-cloned'}
            timestamp={event.changeTime}
            actor={event.actor}
            action={action}
        />
    );
}
